import { TApplicationState } from '../../types/redux';

export function isConsultantChatOpenedSelector(state: TApplicationState) {
  return state.consultantChat.isOpen;
}

export const selectWebimAccountName = (state: TApplicationState) => state.settings.webimAccountName;

export const selectWebimHost = (state: TApplicationState) => state.settings.webimHost;

export const selectWebimLocation = (state: TApplicationState) => state.settings.webimLocation;
